export default __webpack_public_path__ + "static/media/automatic.146c99ad.svg";